import { gql } from "@apollo/client";

// All incident operations are scoped server-side to the logged-in customer's own
// sites (from the auth token) - there's deliberately no customerId variable here.

export const getCustomerIncidentDashboardQuery = gql`
query($input: CustomerIncidentFilter){
  getCustomerIncidentDashboard(input: $input) {
    message
    response
  }
}
`;

export const getCustomerSiteIncidentsQuery = gql`
query($input: CustomerIncidentFilter){
  getCustomerSiteIncidents(input: $input) {
    message
    response
    totalCount
    totalPages
    currentPage
  }
}
`;

export const getCustomerSiteIncidentDetailQuery = gql`
query($id: String!){
  getCustomerSiteIncidentDetail(_id: $id) {
    message
    response
  }
}
`;

// navbar bell - unread count + the latest few incidents
export const getCustomerIncidentAlertsQuery = gql`
query{
  getCustomerIncidentAlerts {
    message
    response
  }
}
`;

export const markCustomerIncidentsSeenMutation = gql`
mutation{
  markCustomerIncidentsSeen {
    message
    response
  }
}
`;
